// All action types

const settings = {
  SHOW_WEBCAM: 'SHOW_WEBCAM',
  SHOW_UPLOAD: 'SHOW_UPLOAD',
  REQUEST_UPDATE_DETAILS: 'REQUEST_UPDATE_DETAILS',
  RECEIVE_UPDATE_DETAILS: 'RECEIVE_UPDATE_DETAILS',
  USER_UPDATED: 'USER_UPDATED',
  EMAIL_CHANGE: 'EMAIL_CHANGE',
  CLOSE_SNACKBAR: 'CLOSE_SNACKBAR',
  EMAIL_ALREADY_GOT: 'EMAIL_ALREADY_GOT',
  EMAIL_ALREADY_GOT_DISABLE: 'EMAIL_ALREADY_GOT_DISABLE'
}

export default settings



// WEBPACK FOOTER //
// src/routes/Settings/actions/actionTypes.js